<template>
  <b-container>
    <Breadcrumbs crumbString="Creative Services,Content Development"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>
          enviroSIGNS has the experience to help you develop text and select graphic elements suited to your communication objectives.
        </div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <b-container class="pods-container">
          <b-row>
            <b-col class="col-12 image-pod">
              <div class="img content-development-full-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/content-development/interpretive-writing01.jpg') + ')'}"></div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-6 col-lg-6 image-pod">
              <div class="img content-development-half-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/content-development/interpretive-writing02.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-6 col-lg-6 image-pod">
              <div class="img content-development-half-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/content-development/interpretive-writing03.jpg') + ')'}"></div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'

  export default {
    components: {
      Breadcrumbs
    },

    data () {
      return {
        title: 'Content Development'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/creativeServices/ContentDevelopment.vue